<template>
    <b-tabs
        class="apprentice-pills-tab"
        v-model="activeTab"
        pills
        vertical
        nav-wrapper-class="col-12 col-sm-3 col-xl-3"
        content-class="col-sm-9 col-xl-9"
        @input="updateTabIndex">
        <b-tab :title="$t('user_account.personal_info')">
            <template v-slot:title>
                <div class="tab-title">
                    <div class="title"><i class="fas fa-home fa-fw"></i> {{ $t('user_account.personal_info') }}</div>
                </div>
            </template>

            <design-2021-user-account-data-component
                :user-in="userIn"
                :courses-in="coursesIn"
                :user-type="userType"></design-2021-user-account-data-component>
        </b-tab>

        <b-tab :title="$t('common.password')">
            <template v-slot:title>
                <div class="tab-title">
                    <div class="title"><i class="fas fa-key fa-fw"></i>{{ $t('common.password') }}</div>
                </div>
            </template>

            <design-2021-user-account-password-component></design-2021-user-account-password-component>
        </b-tab>

        <b-tab :title="$t('user_account.notifications')">
            <template v-slot:title>
                <div class="tab-title">
                    <div class="title"><i class="fas fa-bell-on"></i>{{ $t('user_account.notifications') }}</div>
                </div>
            </template>

            <design-2021-user-settings-component
                :user-in="userIn"
                :user-type="userType"></design-2021-user-settings-component>
        </b-tab>

        <b-tab
            v-if="
                userIn.las_student === null &&
                userIn.las_employee === null &&
                (userType !== 'organization' || userType === null)
            "
            :title="$t('user_account.sign_in.by_school')">
            <template v-slot:title>
                <div class="tab-title">
                    <div class="title">
                        <i class="fas fa-school fa-fw"></i>{{ $t('user_account.sign_in.by_school') }}
                    </div>
                </div>
            </template>

            <design-2021-user-account-school-signin-component
                :user-in="userIn"></design-2021-user-account-school-signin-component>
        </b-tab>
    </b-tabs>
</template>

<script>
export default {
    name: 'design-2021-user-account-component',
    props: {
        userIn: Object,
        userType: {
            type: String,
            default() {
                return null;
            },
        },
        coursesIn: {
            type: Array,
            default: null,
        },
    },
    data() {
        return {
            activeTab: 0,
        };
    },
    methods: {
        updateTabIndex(tabIndex) {
            localStorage.accountTab = tabIndex;
        },
    },
};
</script>

<style scoped></style>
